import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, InputLabel, List, MenuItem, Paper, Select, Stack, TextField, TextareaAutosize } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';
import SalesOverview from 'app/shared/metrics/SalesOverview';
import UserOrders from 'app/shared/metrics/UserOrders';
import Documents1 from 'app/shared/widgets/Documents1';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import Ideas1 from 'app/shared/widgets/Ideas1';
import DiamondIcon from '@mui/icons-material/Diamond';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import * as yup from "yup";
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import UserSummary from 'app/shared/widgets/UserSummary';
import React, { useCallback, useEffect, useState } from 'react';
import UserProfileCard1 from 'app/shared/widgets/UserProfileCard1';
import { DataGrid } from '@mui/x-data-grid';
import { isMobileDevice } from 'app/utils/modifyArrayOfObjectsKeys';
import { formatDate } from '../partStoneStatus/partStoneStatus';
import JumboCardFeatured from '@jumbo/components/JumboCardFeatured';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import FeedItem from 'app/shared/widgets/DailyFeed/FeedItem';
import styled from '@emotion/styled';
import { number } from 'prop-types';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { LoadingButton } from '@mui/lab';
const validationSchema = yup.object({
  FL_BANK_CODE:  yup.string().required('Bank is required'),
  term: yup.string().required('Term is required'),
  PARTY: yup.string().required('Please Select Party'),
  date: yup.string().required('Please Select date'),
})
const Perfoma = () => {
  const [permoaData,setpermoaData]=useState(null)
  const [SelectedStone,setSelectedStone]=useState([])
  const [selecedsummrydata,setSelecedsummrydata]=useState({})
  const [helperdata,sethelperdata]=useState({})
  const [open,setopen]=useState(false)
  const isMobile = isMobileDevice();
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
useEffect(()=>{
  let SelectedStoneData= permoaData?.filter(s=>SelectedStone.includes(s.STONE)) || []
// console.log(SelectedStoneData);
let disc = SelectedStoneData.map(s=> s.MDISC).reduce((accumulator, currentValue) => accumulator + currentValue, 0)/SelectedStoneData.length;
let rap = SelectedStoneData.map(s=> s.RAP_PRICE).reduce((accumulator, currentValue) => accumulator + currentValue, 0)/SelectedStoneData.length;
let convRate = SelectedStoneData.map(s=> s.FL_CONV_RATE).reduce((accumulator, currentValue) => accumulator + currentValue, 0)/SelectedStoneData.length;
let carats = SelectedStoneData.map(s=> s.CARATS).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
let TotalRMDAMT = SelectedStoneData.map(s=> s.MDISC2).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
let amt1 = TotalRMDAMT/convRate
let amt2 = TotalRMDAMT
setSelecedsummrydata({disc,rap,convRate,carats,amt1,amt2})
// console.log({disc,rap,convRate,carats});
},[SelectedStone])
  let columns=[
    { field: 'PARTY', width:130,flex:1, headerName: 'Party',headerClassName: 'TopHeader'},
    { field: 'STONE', headerName: 'stone',headerClassName: 'TopHeader'},
    { field: 'SHAPE', headerName: 'Shape'},
    { field: 'COLOR', width:30, headerName: 'Color'},
    { field: 'CLARITY', width:80,headerName: 'Clarity'},
    { field: 'LAB',width:30, headerName: 'Lab'},
    { field: 'CARATS', width:80,headerName: 'Carats',renderCell:({value})=>value?.toFixed(2)},
    { field: 'RAP_PRICE',width:80, headerName: 'Rap'},
    { field: 'MDISC', width:80,headerName: 'Disc', renderCell:({value})=>value?.toFixed(2)},
    { field: 'FL_SALEAMT', headerName: 'AMT($)',type:"number",renderCell:({row})=>(row.FL_SALERATE*row.CARATS)?.toFixed(2)},
    { field: 'MDISC2', type:"number",headerName: 'AMT(RMB)', flex:0,shrink:0,renderCell:({value})=>value?.toFixed(2)},
    { field: 'FL_BILL_NO',width:150, headerName: 'Bill'},
    { field: 'FL_TRANS_DATE', headerName: 'Date',renderCell:({value})=>formatDate(value)},
    ]
  const swal = useSwalWrapper();
  const init = async ()=>{
   await jwtAuthAxios.get('/master/getPermoaDetails').then(res=>{
      setpermoaData(res.data.rows)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
    await jwtAuthAxios.get('/master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=VAT_ON_SALES&party=1&leadgerdetail=22').then(res=>{
      sethelperdata(res.data?.data)
    }).catch(e=>{
      swal.fire({
        icon:"error",
        text:e
      })
    })
  }
  useEffect(()=>{
    init()
  },[])
  return (<JumboCardQuick title={'Generate Tax Invoice'} action={<Button disabled={!SelectedStone.length > 0} sx={{minWidth: 92}}  variant={"contained"} size={"small"} onClick={()=>setopen(true)} startIcon={<ReceiptLongOutlinedIcon/>}> Generate Tax Invoice</Button>}>
      <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1, mt: 0 }} >
                  <Item>Pcs:  {SelectedStone?.length || 0}</Item>
                  <Item>CTS:  {Number(selecedsummrydata?.carats)&& selecedsummrydata?.carats?.toFixed(2) || 0}</Item>
                  <Item>Rap:  {Number(selecedsummrydata?.rap)&& selecedsummrydata?.rap?.toFixed(2) || 0}</Item>
                  <Item>Disc:  {Number(selecedsummrydata?.disc)&& selecedsummrydata?.disc?.toFixed(2) || 0}</Item>
                  <Item>Conv Rate:  {Number(selecedsummrydata?.convRate)&& selecedsummrydata?.convRate?.toFixed(2) || 0}</Item>
                  <Item>Total AMT($):  {Number(selecedsummrydata?.amt1)&& selecedsummrydata?.amt1?.toFixed(2)|| 0}</Item>
                  <Item>Total AMT(RMB):  {Number(selecedsummrydata?.amt2)&& selecedsummrydata?.amt2?.toFixed(2)|| 0}</Item>
                  </Stack>
    {/* <Paper  title='Single result' sx={{overflow:'auto'}}> */}
        <div style={{height:'80vh',minWidth:isMobile?'1800px':'1300px'}}>
      {permoaData== null? <TableSkeleton cols={22} row={11}/>:permoaData.length >0 ?<DataGrid
        rows={permoaData || []}
        columns={columns}
        checkboxSelection
        rowSelectionModel={SelectedStone}
        onRowSelectionModelChange={e=>setSelectedStone(e)}
        density='compact'
        getRowId={(row) => row.STONE}
        rowsPerPageOptions={[50, 100, 500]}
        rowCount={(permoaData && permoaData.length) || 0}
        pagination

        stickyHeader
      />: <NoDataPlaceholder/>} </div>
      {/* </Paper> */}
      <ShippingFormSoldDialog callback={init} permoaData={permoaData} open={open} selecedsummrydata={selecedsummrydata} helperdata={helperdata} SelectedStone={SelectedStone} handleClose={()=>setopen(false)}/>
      {/* <Dialog open={open} sx={{ minWidth: '650px' }} onClose={()=>setopen(false)}>
      <DialogTitle>Genrate Tax Invoice</DialogTitle>
      <DialogContent>
        </DialogContent></Dialog> */}
      </JumboCardQuick>
  )
};
const ShippingFormSoldDialog = ({callback,permoaData, SelectedStone,selecedsummrydata, userSelectedParty=1, open, handleClose,helperdata }) => {
   
  const [ButtonLoadng, setButtonLoadng] = useState(false)
  const [stoneDataDetailData, setStoneDataDetailData] = useState([])
  const [stoneDataDetail, setStoneDataDetail] = useState(null)
  const [CurrencyName, setCurrencyName] = useState(null)
  const swal = useSwalWrapper()
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  // useEffect(() => {
  //   let sdataD = basketData?.filter((sdata => SelectedStone.includes(sdata.STONE)))
  //   // console.log(sdataD);
  //   setStoneDataDetailData(sdataD)
  // }, [SelectedStone])
  // useEffect(() => {
  //   console.log(basketData);
  // }, [basketData])
  // useEffect(() => {
  //   let TMPOBJ = {
  //     pcs: stoneDataDetailData.length,
  //     cts: stoneDataDetailData.reduce((acc, obj) => acc + obj.CARATS, 0),
  //     disc: ((stoneDataDetailData.reduce((acc, obj) => acc + obj.MDISC, 0)) / stoneDataDetailData.length),
  //     rap: (stoneDataDetailData.reduce((acc, obj) => acc + obj.RAP_PRICE, 0) / stoneDataDetailData.length)
  //   }
  //   setStoneDataDetail({ ...TMPOBJ, price: (TMPOBJ?.rap - ((TMPOBJ?.rap * TMPOBJ?.disc) / 100)) })
  // }, [basketData, stoneDataDetailData])
  const handleSubmit = async (values, { resetForm }) => {
    // alert(JSON.stringify(values))
    // // Handle form submission logic here
    if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
      // let SelectedData = basketData.filter((sdata => SelectedStone.includes(sdata.STONE)))
      setButtonLoadng(true)
      let stoneDataDetailData= permoaData.filter((sdata => SelectedStone.includes(sdata.STONE)));
      // resetForm();
      await jwtAuthAxios.post(`transation/polishOutward`, { ...values, Party: values.PARTY, transactionType: 35, StoneData: stoneDataDetailData, isDetail: 'Y',taxInvoice:true,date: formatDate(values.date)}).then((res) => {
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        resetForm();
        handleClose();
        callback()
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
      }).finally(() => {
        setButtonLoadng(false)
      })
    } else {
      swal.fire({
        icon: 'error',
        text: 'Please Fill Detail',
      });
    }
  };
  const jumboco = useJumboAuth();
  const [initialValues, setInitialValues] = useState({
    shippingNumber: '',
    FL_BANK_CODE: '',
    term: '',
    PARTY: '',
    shipBy: 37,
    ShipingCharge: 0,
    CertCharge: 0,
    narration: '',
    OtherCharge: 0,
    Discount: 0,
    wat_per: helperdata?.TAX?.FL_TAX_PER,
    date: '',
    FL_CURR_CODE: '2',
    FL_CONV_RATE: 0,
  });
  useEffect(()=>{
    // alert(helperdata?.TAX?.FL_TAX_PER)
    setInitialValues({...initialValues,FL_CONV_RATE:selecedsummrydata.convRate,wat_per: helperdata?.TAX?.FL_TAX_PER})
  },[selecedsummrydata,helperdata])

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Sold Shipping Information</DialogTitle>
      <DialogContent >
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ handleSubmit, values, setFieldValue,errors }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item lg={12} xs={12}>
                <Grid item xs={12}>
                    <InputLabel>Select Bank</InputLabel>
                    <Field size="small" name="FL_BANK_CODE" InputLabel="Select Bank" as={Select} fullWidth>
                      <MenuItem value="">Select Select Bank</MenuItem>
                      {helperdata?.leadgerdetail?.map(item => <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>)}
                    </Field>
                    {errors.FL_BANK_CODE && (
                    <div className="error">{errors.FL_BANK_CODE}</div>
                  )}
                  </Grid>
                  <Field name="PARTY" as={TextField} error={Boolean(errors.PARTY)} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Party" fullWidth>
                    {helperdata?.PARTY?.map((option) => (
                      <MenuItem key={option.FL_PARTY_CODE} value={option.FL_PARTY_CODE}>
                        {option.FL_PARTY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                <ErrorMessage name="PARTY" component="div" className="error"/>

                </Grid>
                <Grid item lg={6} xs={12}>
                  <Field  name="FL_CURR_CODE" disabled as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Currency Type" fullWidth>
                    {helperdata?.CURR?.map((option) => (
                      <MenuItem key={option.FL_CURRENCY_ID} onClick={(e) => { setCurrencyName(option.FL_CURRENCY_NAME) }} value={option.FL_CURRENCY_ID}>
                        {option.FL_CURRENCY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item lg={6} xs={12}>
                  <Field name="FL_CONV_RATE" disabled as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} type="number" label="Conv Rate" fullWidth />
                </Grid>
              </Grid>

              <Field name="term"  error={Boolean(errors.term)} as={TextField}   style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Payment Term" fullWidth>
                {helperdata?.TERM?.map((option) => (
                  <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
                    {option.FL_TERM_NAME}
                  </MenuItem>
                ))}
              </Field>
                <ErrorMessage name="term" component="div" className="error"/>
              <Field name="shippingNumber" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shipping Number" fullWidth />
              <Field name="shipBy" as={TextField} disabled style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Ship By" fullWidth>
                {helperdata?.SHIPPEDBY?.map((option) => (
                  <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                    {option.FL_PARA_VALUE}
                  </MenuItem>
                ))}
              </Field>
              <Grid container columnSpacing={2}>
                <Grid item lg={6} xs={12}>
                  <Field name="wat_per" as={TextField} disabled type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="vat Charge(%)" fullWidth />
                </Grid>
                <Grid item lg={6} xs={12}>
                <Field name="date" as={TextField} type="date" style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small',shrink:true }} label="Date" fullWidth  error={Boolean(errors.date)}/>
                <ErrorMessage name="date" component="div" className="error"/>

                </Grid>
                {/* <Grid item lg={6} xs={12}>
                  <Field name="ShipingCharge" as={TextField} disabled type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shiping Charge(AMT)" fullWidth />
                </Grid> */}
                {/* <Grid item lg={6} xs={12}>
                  <Field name="CertCharge" as={TextField} disabled type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Cert. Charge(AMT)" fullWidth />
                </Grid> */}
                {/* <Grid item lg={6} xs={12}>
                  <Field name="OtherCharge" as={TextField} disabled type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="OtherCharge(AMT)" fullWidth />
                </Grid> */}
                {/* <Grid item lg={6} xs={12}>
                </Grid> */}
              </Grid>
              {/* <Field name="Discount" as={TextField} type="number" disabled min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Discount(-AMT)" fullWidth /> */}
              <InputLabel>Naration</InputLabel>
              <Field size="small"
                component={TextareaAutosize}
                name="narration"
                label="Naration"
                minRows={3}
                onChange={(e) => setFieldValue('narration', e.target.value)}
                style={{ width: '100%' }}
                fullWidth
              />
              {/* <Field
                name="is_p"
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        style={{ margin: '5px 0' }}
                        size="small"
                      // checked={field.value}
                      // Add any other Checkbox props here
                      />
                    }
                    label="IS P"
                    fullWidth
                  />
                )}
              /> */}
              <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1, mt: 3 }} >
                <Item>Pcs  {SelectedStone?.length || 0}</Item>
                <Item>CTS  {selecedsummrydata?.carats?.toFixed(2) || 0.00}</Item>
                <Item>Rap  {selecedsummrydata?.rap.toFixed(2) || 0}</Item>
                <Item>Disc%  {selecedsummrydata?.disc?.toFixed(2) || 0}</Item>
                <Item>vat%  {values.wat_per || 0}</Item>
              </Stack>
              {/* <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
                <Item>ShipingCharge ($AMT) = {values.ShipingCharge || 0}</Item>
                <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
              </Stack> */}
              <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
                <Item>Price/cts($) = {((selecedsummrydata.amt1+(selecedsummrydata.amt1 * (values.wat_per/100)))/Number(selecedsummrydata?.carats ||0)).toFixed(2)}</Item>
                {/* <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge -values.Discount) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item>
                  <Item>Total Amt ({CurrencyName || 'RMB'}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item> */}
                <Item>Total Amt ($) = {(selecedsummrydata.amt1+(selecedsummrydata.amt1 * (values.wat_per/100))).toFixed(2)}</Item>
                <Item>Total Amt ({CurrencyName || 'RMB'}) = {((selecedsummrydata.amt1+(selecedsummrydata.amt1 * (values.wat_per/100)))*values.FL_CONV_RATE).toFixed(2)}</Item>
              </Stack>
              <LoadingButton loading={ButtonLoadng} variant="contained" color='primary' sx={{ display: 'block', marginLeft: 'auto', mt: 3 }} type="submit">Sold</LoadingButton>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};
Perfoma.Modulename = 'PerfomaGenrate';
export default Perfoma;
